// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Notifications from 'vue-notification'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueClipboard from 'vue-clipboard2'

let init = () => {
  Vue.config.productionTip = false
  VueClipboard.config.autoSetContainer = true // add this line
  Vue.use(VueClipboard)
  Vue.use(Notifications)
  Vue.use(BootstrapVue)
  Vue.use(IconsPlugin)

  /* eslint-disable no-new */
  window.vm = new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}

init()



// WEBPACK FOOTER //
// ./src/main.js